import DateUtils from 'js/lib/DateUtils';

export const columns = [
  {
    name: 'Domain',
    field: 'name',
  },
  {
    name: 'Data Products',
    field: 'items_count',
  },
  {
    name: 'Date Created',
    field: 'created_at',
    renderRow(row) {
      return DateUtils.getDateString(row.created_at);
    },
  },
  {
    name: 'Date Modified',
    field: 'updated_at',
    renderRow(row) {
      return DateUtils.getDateString(row.updated_at);
    },
  },
];
